import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Integrating a Freon Editor into Your Own Web App",
description: "How to embed a Freon editor into a custom web application. Uses a monorepo setup (DSL + Flowbite web app), references the IntegrationExample GitHub repo, and points to relevant Freon core and core-svelte functionality.",
tags: [ "Freon", "Integration", "Svelte", "Flowbite", "core", "core-svelte", "monorepo", "web app", "editor embedding", "Getting Started", "documentation"] ,
modifiedTime: "2025-11-07T19:06:34.439Z",
publishedTime: "2025-11-07T17:20:18.642Z"
    }
  };
};